export const c_accordion_m_bordered__expanded_content_m_expanded__expanded_content_body_last_child_after_BorderBottomColor = {
  "name": "--pf-c-accordion--m-bordered__expanded-content--m-expanded__expanded-content-body--last-child--after--BorderBottomColor",
  "value": "#d2d2d2",
  "var": "var(--pf-c-accordion--m-bordered__expanded-content--m-expanded__expanded-content-body--last-child--after--BorderBottomColor)"
};
export default c_accordion_m_bordered__expanded_content_m_expanded__expanded_content_body_last_child_after_BorderBottomColor;